// extracted by mini-css-extract-plugin
export default {"banner":"LeadershipHomePageHero_banner__2WfdT","title":"LeadershipHomePageHero_title__5-J4p","boxImg":"LeadershipHomePageHero_boxImg__j0cP8"};